import { useSelector } from "react-redux";

import { selectCurrentUserIsVoltEmployee } from "../store/auth.slice";

export const useIsCurrentUserVoltEmployee = () => {
  return useSelector(selectCurrentUserIsVoltEmployee);
};
